export const TIMELINE_FILTERS = Object.freeze({
  ALL: 'ALL',
  SYSTEM_INFO: 'SYSTEM_INFO',
  EMAILS: 'EMAILS',
  COMMENTS: 'COMMENTS',
  ACTIONS: 'ACTIONS',
})

export const ReadableTimelineFilters = Object.freeze({
  ALL: 'lead-timeline.filters.all',
  SYSTEM_INFO: 'lead-timeline.filters.system_info',
  EMAILS: 'lead-timeline.filters.emails',
  COMMENTS: 'lead-timeline.filters.comments',
  ACTIONS: 'lead-timeline.filters.actions',
})
